import { useEffect } from 'react';
import { fetchAndCacheTenantBranding } from '../utils/tenantBranding';

/** Loads tenant branding from the core API before paint-critical children render. */
const TenantBrandingBootstrap: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    void fetchAndCacheTenantBranding().then(() => {
      window.dispatchEvent(new Event('tenantBrandingLoaded'));
    });
  }, []);

  return <>{children}</>;
};

export default TenantBrandingBootstrap;
